// src/components/PortfolioSection.js
import React from 'react'; // Only React import is needed now

// No GSAP/ScrollTrigger imports or registration needed here anymore

// Accept openPortfolioModal function as a prop
function PortfolioSection({ openPortfolioModal }) {

  // No ref needed as animation is removed
  // No useEffect needed as animation is removed

  return (
    <section id="portfolio">
      <div className="container">
        <h2>시공 사례</h2>
        <p>
          맑은뷰연구소의 최근 시공 사례들을 확인해보세요.
          다양한 환경에서의 전문적인 청소 결과를 보실 수 있습니다.
        </p>

        {/* Centering Wrapper Div */}
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '30px' /* Optional: Adjust margin-top as needed */ }}>
          <button
            className="cta-button" // Button retains its core styling
            onClick={openPortfolioModal}
          >
            최신 시공 사례 보기
          </button>
        </div>
        {/* End Centering Wrapper Div */}

      </div>
    </section>
  );
}

export default PortfolioSection;